import React from 'react';
// import { CartProvider } from './pages/Context/CartContext';

// Import SCSS
import './assets/scss/themes.scss';

// Import Routes (renamed to avoid confusion with react-router's <Route>)
import Routes from './Routes';

// import fakeBackend from "./helpers/AuthType/fakeBackend";

// // Initialize fake backend
// fakeBackend();

function App() {
  return (
    <React.Fragment>
      
        <Routes />
     
    </React.Fragment>
  );
}

export default App;
